import MonitoringQueueEntryScoringDetailsTable from './MonitoringQueueEntryScoringDetailsTable';

export default MonitoringQueueEntryScoringDetailsTable;


// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/components/scoring/scoring-details-table/index.js